import classNames from "classnames";

import { Typography } from "../Typography";
import styles from "./Heading1.module.scss";

export const Heading1 = ({
  as = "h1",
  className,
  color,
  children,
  plain = false,
}) => (
  <Typography
    className={classNames(className, styles.element)}
    color={color}
    as={as}
    plain={plain}
  >
    {children}
  </Typography>
);
